import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import PermissaoUsuario from '../../auth/permissao';
import { createCategoria, updateCategoria, resetCategoriaForm } from './inventarioActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Grid from '../../common/layout/grid';
import Button from '../../common/form/button';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { filtrarPorTexto, premiumBadge } from '../manutencaoListUtils';

const BADGE_OPTS = [
  { value: 'os-badge--amber', label: 'Âmbar' },
  { value: 'os-badge--blue', label: 'Azul' },
  { value: 'os-badge--violet', label: 'Violeta' },
  { value: 'os-badge--teal', label: 'Verde-água' },
  { value: 'os-badge--green', label: 'Verde' },
  { value: 'os-badge--gray', label: 'Cinza' },
  { value: 'os-badge--red', label: 'Vermelho' },
  { value: 'os-badge--orange', label: 'Laranja' },
];

const BADGE_LABEL = BADGE_OPTS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

const FILTRO_TODOS = '';
const selector = formValueSelector('inventarioCategoriaForm');

class InventarioCategoriaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroAtivo: FILTRO_TODOS,
      paginaAtual: 0,
    };
    this.toggleAtivo = this.toggleAtivo.bind(this);
    this.editar = this.editar.bind(this);
    this.salvar = this.salvar.bind(this);
  }

  salvar(values) {
    if (values.id) {
      this.props.updateCategoria({ id: values.id }, values);
      return;
    }
    this.props.createCategoria(values);
  }

  toggleAtivo(categoria) {
    this.props.updateCategoria(categoria, { ativo: !categoria.ativo });
  }

  editar(categoria) {
    this.props.resetCategoriaForm({
      id: categoria.id,
      nome: categoria.nome,
      descricao: categoria.descricao || '',
      badge_class: categoria.badge_class || 'os-badge--gray',
      ordem: String((categoria.ordem !== null && categoria.ordem !== undefined) ? categoria.ordem : 0),
      codigo: categoria.codigo,
    });
  }

  renderAcoes(row) {
    const item = row.original;

    return (
      <div className="os-actions-cell">
        <div className="os-actions-group">
          <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
            <SPButton
              type="button"
              className="warning btn-sm"
              icon="pencil-alt"
              data-title="Alterar"
              onClick={() => this.editar(item)}
            />
            <SPButton
              type="button"
              className={item.ativo ? 'default btn-sm' : 'success btn-sm'}
              icon={item.ativo ? 'eye-slash' : 'eye'}
              data-title={item.ativo ? 'Desativar' : 'Ativar'}
              onClick={() => this.toggleAtivo(item)}
            />
          </PermissaoUsuario>
        </div>
      </div>
    );
  }

  getCategoriasFiltradas() {
    const { categorias } = this.props;
    let lista = categorias || [];
    lista = filtrarPorTexto(lista, ['nome', 'descricao', 'codigo'], this.state.filtroBusca);
    if (this.state.filtroAtivo !== FILTRO_TODOS) {
      const esperado = this.state.filtroAtivo === '1';
      lista = lista.filter(c => !!c.ativo === esperado);
    }
    return lista;
  }

  renderStats(total, ativos) {
    return (
      <div className="inventario-tipos-stats">
        <span>
          <strong>{total}</strong> categorias cadastradas
        </span>
        <span>
          <strong>{ativos}</strong> ativas
        </span>
      </div>
    );
  }

  renderFiltros() {
    const { filtroBusca, filtroAtivo } = this.state;

    return (
      <div className="os-list-filters-bar inventario-tipos-filters">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="inv-cat-busca">
            Buscar
          </label>
          <input
            id="inv-cat-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={e => this.setState({ filtroBusca: e.target.value, paginaAtual: 0 })}
            placeholder="Nome, código ou descrição..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label">Situação</label>
          <select
            className="form-control os-list-filter-select"
            value={filtroAtivo}
            onChange={e => this.setState({ filtroAtivo: e.target.value, paginaAtual: 0 })}
          >
            <option value={FILTRO_TODOS}>Todas</option>
            <option value="1">Ativas</option>
            <option value="0">Inativas</option>
          </select>
        </div>
      </div>
    );
  }

  renderForm() {
    const { editingId, codigo } = this.props;
    const isEdit = !!editingId;

    return (
      <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
        <form onSubmit={this.props.handleSubmit(this.salvar)} className="simple-cad-form-premium manutencao-cad-premium inventario-tipos-form">
          <div className="simple-cad-premium-container">
            <div className="simple-cad-premium-card">
              <div className="simple-cad-premium-header">
                <h4>
                  <i className="fa fa-layer-group" /> {isEdit ? 'Editar categoria' : 'Nova categoria'}
                </h4>
                <p>Agrupa os tipos de equipamento no inventário. O código interno é gerado automaticamente.</p>
              </div>
              <div className="simple-cad-premium-body inventario-tipos-form-grid">
                <Field name="nome" component={LabelAndInput} label="Nome" cols="12 3" placeholder="Ex.: Semafórico" />
                <Field name="descricao" component={LabelAndInput} label="Descrição" cols="12 3" placeholder="Opcional" />
                <Field name="badge_class" component={LabelAndSelectForm} label="Cor de destaque" cols="12 2">
                  {BADGE_OPTS.map(b => (
                    <option key={b.value} value={b.value}>
                      {b.label}
                    </option>
                  ))}
                </Field>
                <Field name="ordem" component={LabelAndInput} label="Ordem" cols="12 1" type="number" placeholder="0" />
                {isEdit && (
                  <Grid cols="12 2">
                    <div className="form-group form-group-sm">
                      <label className="label-gt">Código</label>
                      <input className="form-control" value={codigo || ''} readOnly />
                    </div>
                  </Grid>
                )}
                <Grid cols="12 1" className="inventario-tipos-form-action">
                  <Button
                    type="submit"
                    className="primary"
                    icon={isEdit ? 'save' : 'plus'}
                    label={isEdit ? 'Salvar' : 'Adicionar'}
                  />
                </Grid>
                {isEdit && (
                  <Grid cols="12 1" className="inventario-tipos-form-action">
                    <Button type="button" className="default" icon="times" label="Cancelar" onClick={() => this.props.resetCategoriaForm()} />
                  </Grid>
                )}
              </div>
            </div>
          </div>
        </form>
      </PermissaoUsuario>
    );
  }

  render() {
    const filtrados = this.getCategoriasFiltradas();
    const total = (this.props.categorias || []).length;
    const ativos = (this.props.categorias || []).filter(c => c.ativo).length;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => this.renderAcoes(row),
        className: 'column_icon',
        width: 90,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Nome',
        accessor: 'nome',
        className: 'column_grid manutencao-col-texto',
        minWidth: 160,
      },
      {
        Header: 'Código',
        accessor: 'codigo',
        className: 'column_grid',
        width: 120,
      },
      {
        Header: 'Cor',
        accessor: 'badge_class',
        className: 'column_grid',
        width: 120,
        Cell: row =>
          premiumBadge(BADGE_LABEL[row.value] || 'Padrão', row.value || 'os-badge--gray'),
      },
      {
        Header: 'Ordem',
        accessor: 'ordem',
        className: 'column_grid',
        width: 70,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        className: 'column_grid manutencao-col-texto',
        minWidth: 180,
        Cell: row => row.value || '—',
      },
      {
        Header: 'Situação',
        accessor: 'ativo',
        className: 'column_grid',
        width: 100,
        Cell: row =>
          premiumBadge(row.value ? 'Ativa' : 'Inativa', row.value ? 'os-badge--green' : 'os-badge--gray'),
      },
    ];

    return (
      <div className="manutencao-premium-list inventario-tipos-premium inventario-categorias-premium">
        <div className="inventario-tipos-intro">
          <div>
            <h4 className="inventario-tipos-title">
              <i className="fa fa-layer-group" /> Catálogo de categorias
            </h4>
            <p>Classificação de alto nível usada pelos tipos de equipamento do inventário.</p>
          </div>
          {this.renderStats(total, ativos)}
        </div>

        {this.renderForm()}
        {this.renderFiltros()}

        <PremiumTableShell>
          <ReactTableGT2A
            data={filtrados}
            columns={columns}
            page={this.state.paginaAtual}
            onPageChange={page => this.setState({ paginaAtual: page })}
            defaultPageSize={12}
            minRows={3}
            noDataText="Nenhuma categoria encontrada."
          />
        </PremiumTableShell>
      </div>
    );
  }
}

InventarioCategoriaList = reduxForm({
  form: 'inventarioCategoriaForm',
  destroyOnUnmount: false,
  initialValues: { badge_class: 'os-badge--gray', ordem: '0', nome: '', descricao: '' },
})(InventarioCategoriaList);

const mapStateToProps = state => ({
  categorias: state.manutencaoInventario.categorias,
  editingId: selector(state, 'id'),
  codigo: selector(state, 'codigo'),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createCategoria, updateCategoria, resetCategoriaForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InventarioCategoriaList);
